<template lang="html">
  <v-container fluid>
    <v-row class="d-flex justify-center my-6">
      <h1>The Team</h1>
    </v-row>

    <v-row class="d-flex justify-space-around">
        <v-card flat max-width="300" v-for="member in team" :key="member.id">
          <v-col>
            <v-img
            class="white--text align-end"
            height="60vh"
            :src="member.img"
            >
              <v-card-title class="font-weight-medium headline">{{ member.name }}</v-card-title>
            </v-img>

            <v-card-text class="text-center">
              <h2 class="font-weight-regular">{{ member.title }}</h2>
            </v-card-text>
          </v-col>
        </v-card>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    // https://imgur.com/a/EKF9zKO
    team: [
      {id: 0, name: 'Md. Abdul', title: 'Software Engineer', img: 'https://i.imgur.com/7snRwzH.jpg'},
      {id: 1, name: 'Atheesh', title: 'Software Engineer', img: 'https://i.imgur.com/4QoqpAq.jpg'},
      {id: 2, name: 'Danny', title: 'Software Engineer', img: 'https://media-exp1.licdn.com/dms/image/C4D03AQG5uwfd8e0x5A/profile-displayphoto-shrink_400_400/0?e=1597276800&v=beta&t=_jaZiVPuHLqAlce2G4xgwYTvRvDGXWObLSdAZSuTTCg'},
      {id: 3, name: 'Asim', title: 'Software Engineer', img: 'https://asimbhatia.me/view/images/profilePic.png'},
    ]
  }),
}
</script>

<style lang="css" scoped>
</style>
